import { useContext } from 'react';
import { Tab }                   from 'semantic-ui-react';
import styled                    from 'styled-components';
// import ConsecutiveFailures       from './ConsecutiveFailures';
import RawConsecutiveFailures    from './RawConsecutiveFailures';
import BrokenRunTests            from './BrokenRunTests';
import AppContext                from '../../../context/HeaderContext';

const Container = styled.div`
	margin: 15px 0 0 -10px;
`;

function Reports() {
	const { current_organization_id } = useContext(AppContext);

	const panes = [
		{
			menuItem : `Consecutive Failures`,
			render   : () => <RawConsecutiveFailures />
		},
		// {
		// 	menuItem : `Consecutive Failures`,
		// 	render   : () => <ConsecutiveFailures />
		// },
		// {
		// 	menuItem : `Flaky Tests`,
		// 	render   : () => <ConsecutiveFailures />
		// }
	];

	if(current_organization_id === 2) {
		panes.push({
			menuItem : `Broken Run Tests`,
			render   : () => <BrokenRunTests />
		});
	}

	return (
		<Container>
			<Tab menu={{ secondary : false, fluid : true, vertical : true, tabular : false }} panes={panes} />
		</Container>
	)
}

export default Reports;
